export default __webpack_public_path__ + "static/grid-breakpoints-light-679e2e1308ac839ae726f3f4619236b4.png";